import React, { useState } from 'react';
import ImageSelector from './components/ImageSelector';
import PuzzleBoard from './components/PuzzleBoard';
import './App.css';

function App() {
  // State für das Puzzle-Spiel
  // eslint-disable-next-line no-unused-vars
  const [puzzlePieces, setPuzzlePieces] = useState([]);
  const [difficulty, setDifficulty] = useState('easy');
  const [isPlaying, setIsPlaying] = useState(false);
  const [selectedImage, setSelectedImage] = useState('/images/puzzle1.jpg');
  const [gameCompleted, setGameCompleted] = useState(false);
  const [gameTime, setGameTime] = useState(0);
  const [rotationEnabled, setRotationEnabled] = useState(false);
  
  // Funktion zum Starten eines neuen Spiels
  const startNewGame = () => {
    setIsPlaying(true);
    setGameCompleted(false);
  };
  
  // Funktion, wenn das Puzzle vollständig ist
  const handleGameComplete = (time) => {
    setGameCompleted(true);
    setGameTime(time);
  };
  
  // Funktion zum Zurückkehren zur Spielauswahl
  const returnToMenu = () => {
    setIsPlaying(false);
  };
  
  // Formatierung der Spielzeit
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  
  return (
    <div className="puzzle-container">
      <header>
        <h1>Puzzle Game</h1>
        <p>Ein interaktives Puzzle-Spiel</p>
      </header>
      
      {!isPlaying ? (
        <div className="game-setup">
          <h2>Neues Spiel starten</h2>
          
          <ImageSelector 
            selectedImage={selectedImage}
            onImageSelect={setSelectedImage}
          />
          
          <div className="difficulty-selector">
            <h3>Schwierigkeitsgrad:</h3>
            <select 
              value={difficulty} 
              onChange={(e) => setDifficulty(e.target.value)}
            >
              <option value="easy">Leicht (3x3)</option>
              <option value="medium">Mittel (4x4)</option>
              <option value="hard">Schwer (5x5)</option>
            </select>

            <div className="ultrahard-option">
              <input 
                type="checkbox" 
                id="rotation-toggle" 
                checked={rotationEnabled}
                onChange={(e) => setRotationEnabled(e.target.checked)}
              />
              <label htmlFor="rotation-toggle">
                Ultraschwer: Drehbare Puzzle-Teile
              </label>
            </div>
          </div>
          
          <button 
            className="start-button" 
            onClick={startNewGame}
          >
            Spiel starten
          </button>
        </div>
      ) : (
        <div className="game-board">
          <PuzzleBoard 
            imageSrc={selectedImage}
            difficulty={difficulty}
            rotationEnabled={rotationEnabled}
            onComplete={handleGameComplete}
            onReturn={returnToMenu}
          />
        </div>
      )}
      
      <footer>
        <p>© {new Date().getFullYear()} Puzzle Game - Alle Rechte vorbehalten</p>
      </footer>
    </div>
  );
}

export default App; 